// extracted by css-extract-rspack-plugin
module.exports =  {"root":"SearchResults__root___SpYLz","above":"SearchResults__above___upGUk","below":"SearchResults__below___F9lQk","empty":"SearchResults__empty___G3HxX"};